<template>
  <explorer-layout header="Bestellungen">
    <template v-slot:select="{explorerSelect}">
      <order-list @select="(selectedOrder = $event) && explorerSelect('Bestellung ' + $event.number)"/>
    </template>
    <template v-slot:work>
      <order-detail :order="selectedOrder"/>
    </template>
  </explorer-layout>
</template>
<script>
import ExplorerLayout from "@/layouts/ExplorerLayout";
import OrderList from "@/components/OrderList";
import OrderDetail from "@/components/order/OrderDetail";

export default {
  data(){
    return {
      selectedOrder: undefined
    }
  },
  components: {OrderDetail, ExplorerLayout, OrderList}
}
</script>
